export default __webpack_public_path__ + "static/media/delete.50198084.svg";